<template>
  <div class="w-full h-full px-5 pt-[14px] pb-[22px] bg-gray-200/20 rounded-xl">
    <div class="flex items-center gap-x-2.5 mb-2">
      <Icon name="Image" :size="22" class="stroke-gray-800" />

      <div
        class="font-secondary font-medium text-[15px] leading-[20px] text-gray-800"
      >
        Image
      </div>
    </div>

    <div class="w-full h-px mb-4 bg-gray-200/50"></div>

    <MatchMarkers :markers="match.markers" />

    <div class="font-secondary text-[12px] leading-[16px] text-gray-500 mb-3">
      Page 1
    </div>

    <div
      class="border relative rounded-[3px]"
      :class="{
        'border-gray-500': !match.level,
        'border-red-500': match.level === ScoreLevel.High,
        'border-yellow-500': match.level === ScoreLevel.Medium,
        'border-green-500': match.level === ScoreLevel.Low,
      }"
    >
      <RouterLink
        :to="viewFullFileTo"
        class="group absolute top-2.5 right-2.5 z-10"
      >
        <UiButton icon="Eye" class="bg-white opacity-30 group-hover:hidden" />

        <UiButton
          icon="Eye"
          class="hidden group-hover:flex bg-white hover:bg-white"
        >
          View full file
        </UiButton>
      </RouterLink>

      <MatchTag
        :id="number"
        :level="match.level"
        class="absolute -top-2 -left-2"
      />

      <img :src="match.url" class="w-full pointer-events-none" />
    </div>
  </div>
</template>

<script lang="ts">
import { graphql } from '@/shared/graphql/router'
import { ScoreLevel } from '@/shared/graphql/router/graphql'

export const ImageMatchFragment = graphql(`
  fragment ImageMatchFields on ImageMatch {
    id
    location
    summary
    url
    level
    markers {
      color
      shine
      visible
    }
  }
`)
</script>

<script setup lang="ts">
import {
  type FragmentType,
  useFragment,
} from '@/shared/graphql/router/fragment-masking'
import MatchTag from './matches/MatchTag.vue'
import MatchMarkers from './MatchMarkers.vue'
import { Icon, UiButton } from '@dacr/ui'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const props = defineProps<{
  match: FragmentType<typeof ImageMatchFragment>
  number: number
  side?: 'registered' | 'infringing'
  allowPlayback?: boolean
}>()

const match = useFragment(ImageMatchFragment, props.match)

const route = useRoute()

const viewFullFileTo = computed(() => ({
  path: `/infringement/report/${route.params.id}/image`,
  query: props.side ? { side: props.side } : undefined,
}))
</script>
